import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { TransformCTA } from '../TransformCTA';
import { faqs } from '../../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white px-5 py-14 sm:py-20" data-id="element-112" data-mp="x5muifdtqpo8">
      <div className="mx-auto w-full max-w-xl lg:max-w-3xl" data-id="element-113" data-mp="123ob8tns2cwj">
        <h2 className="text-center font-display text-[26px] font-bold leading-tight text-ink-900 sm:text-[34px]" data-id="element-114" data-mp="1ps7j582x0no3">
          ❓ Frequently Asked Questions
        </h2>

        <ul className="mt-9 divide-y divide-bone-200 border-y border-bone-200" data-id="element-115" data-mp="1uqitrl11b27d">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-116" data-mp="1kzwlyczk7fz8" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-start justify-between gap-4 py-4 text-left" data-id="element-117" data-mp="28r20motrk27y">
                  <span className="text-[15px] font-bold leading-snug text-ink-900 sm:text-base" data-id="element-118" data-mp="2oqiebzs8g0c4">
                    {faq.q}
                  </span>
                  <ChevronDownIcon className={`mt-0.5 h-5 w-5 shrink-0 text-teal-700 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-119" data-mp="2yga8iswf6rg2" />
                </button>
                {isOpen && <p className="-mt-1 pb-5 pr-8 text-[14px] leading-relaxed text-ink-900/65 sm:text-[15px]" data-id="element-120" data-mp="32h3zxw92modp">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>

        <TransformCTA tone="light" headline="Start your Male Fertility Route today." data-id="element-121" data-mp="1n0vcbrc1c3m0" />
      </div>
    </section>;
}